import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducers'

// atoms
import InputField from '../../../atoms/InputField'
import SelectField from '../../../atoms/SelectField'
import TextareaField from '../../../atoms/TextareaField'
import TypeCheckboxGroupField from '../../../atoms/TypeCheckboxGroupField'

// interfaces
import { ITemplate } from '../../../types/interfaces'

// utils
import { FORM } from '../../../utils/enums'

// validate
// eslint-disable-next-line import/no-cycle
import validateGeneralSettingsForm from '../../../components/forms/validations/validateGeneralSettingsForm'

export type ComponentProps = {}

type Props = InjectedFormProps<ITemplate, ComponentProps> &
	ComponentProps & {
		handleSubmit: Function
	}

const TemplateGeneralSettingsForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit } = props
	const queue = useSelector((state: RootState) => state.formTemplate.queue)
	const databases = useSelector((state: RootState) => state.formTemplate.databases)
	const disable = useSelector((state: RootState) => state.template.disable)

	return (
		<Form layout={'vertical'} onSubmitCapture={handleSubmit}>
			<Row justify={'center'} className={'mt-2 w-full'}>
				<Col span={24}>
					<Field
						component={InputField}
						label={t('loc:Template name')}
						placeholder={t('loc:Enter name')}
						name={'name'}
						size={'large'}
						disabled={disable}
						required
					/>
				</Col>
				<Col span={24}>
					<Field
						component={SelectField}
						label={t('loc:Daktela front')}
						placeholder={t('loc:Select front')}
						name={'formQueue'}
						loading={queue?.isLoading}
						options={queue?.data}
						size={'large'}
						disabled={disable}
						clearBtn={true}
					/>
				</Col>
				<Col span={24}>
					<Field
						component={SelectField}
						label={t('loc:Database')}
						placeholder={t('loc:Select database')}
						name={'formDatabase'}
						loading={databases?.isLoading}
						options={databases?.data}
						size={'large'}
						disabled={disable}
						clearBtn={true}
					/>
				</Col>
				<Col className={'mt-1'} span={24}>
					<Field component={TypeCheckboxGroupField} name={'formType'} size={'large'} disabled={disable} required />
				</Col>
				<Col className={'mt-1'} span={24}>
					<Field label={t('loc:Description')} component={TextareaField} name={'description'} disabled={disable} minHeight={80} />
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<ITemplate, ComponentProps>({
	form: FORM.TEMPLATE_GENERAL_SETTINGS,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	validate: validateGeneralSettingsForm,
	onChange: debounce((values, dispatch, props) => {
		if (props.anyTouched) {
			props.submit()
		}
	}, 600)
})(TemplateGeneralSettingsForm)

export default form
